import React from 'react'
import ReactMarkdown from 'react-markdown'
import { injectIntl, intlShape } from 'react-intl'
import Helmet from 'react-helmet';
import get from 'lodash/get';

import './ContentBlocks.css'

const FullbleedHero = (props) => (
  <div className="fullbleed hero">
    {get(props, 'fields.lead') &&     
      <Helmet
        meta={[
          {"name": "description", "content": get(props, 'fields.lead')},
          {"property": "og:description", "content": get(props, 'fields.lead')}
        ]}
      />
    }
    {(get(props, 'fields') && !get(props, 'dual')) &&
      <div className="container">
        <div>
          {get(props, 'fields.heading') && <h1>{props.fields.heading}</h1>}

          {(get(props, 'fields.lead') && props.slug!=='reservation') && 
            <div className="lead">
              <ReactMarkdown source={get(props, 'fields.lead')} softBreak="br" />
            </div>
          }

          {
            (get(props, 'fields.ctaText') && (get(props, 'fields.ctaInternalLink') || get(props, 'fields.ctaExternalLink'))) && 
            <a href={get(props, 'fields.ctaInternalLink') ? get(props, 'fields.ctaInternalLink.fields.slug') : get(props, 'fields.ctaExternalLink')} className="btn">
              {get(props, 'fields.ctaText')}
            </a>
          }
        </div>
      </div>
    }
    {get(props, 'dual') &&
      <div className="container dual-container">
        {get(props, 'fields').map((key, i) => (
          <div key={key.sys.id}>
            {get(key, 'fields.heading') && <h1>{key.fields.heading}</h1>}

            {(get(key, 'fields.lead') && key.slug!=='reservation') && 
              <div className="lead">
                <ReactMarkdown source={get(key, 'fields.lead')} softBreak="br" />
              </div>
            }

            {
              (get(key, 'fields.ctaText') && (get(key, 'fields.ctaInternalLink') || get(key, 'fields.ctaExternalLink'))) && 
              <a href={get(key, 'fields.ctaInternalLink') ? get(key, 'fields.ctaInternalLink.fields.slug') : get(key, 'fields.ctaExternalLink')} className="btn">
                {get(key, 'fields.ctaText')}
              </a>
            }
          </div>
        ))}
      </div>
    }
  </div>
)

FullbleedHero.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(FullbleedHero)


// WEBPACK FOOTER //
// ./src/components/ContentBlocks/FullbleedHero.js